// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Cy-z","tooltipWrapper":"Dy-z","icon":"Ey-z","tooltip":"Fy-z","content":"Gy-z"};